import React from 'react';
import { node, oneOfType, string } from 'prop-types';
import { styBreadcrumbSeparator } from './style';

const BreadcrumbSeparator = ({ children, ...props }) => (
  <li className={styBreadcrumbSeparator} {...props}>
    {children}
  </li>
);
BreadcrumbSeparator.propTypes = {
  children: oneOfType([node, string]),
};

BreadcrumbSeparator.defaultProps = {
  children: null,
};

export default BreadcrumbSeparator;
